import { obtenerRango } from "../funciones/rangos";
import React, {
	useEffect,
	useState
} from "react";

import styled from "styled-components";

import {
	collection,
	getDocs
} from "firebase/firestore";

import { db } from "../firebase/firebaseConfig";

import { useAuth } from "../contextos/AuthContext";

const Contenedor = styled.div`
	min-height: 100vh;

	padding: 2rem;

	background:
		radial-gradient(
			circle at top,
			#1f2937 0%,
			#0b1120 45%,
			#050816 100%
		);

	color: white;
`;

const Titulo = styled.h1`
	font-size: 2.5rem;

	margin-bottom: 2rem;
`;

const Tabla = styled.div`
	display: flex;
	flex-direction: column;

	gap: 1rem;
`;

const Fila = styled.div`
	display: grid;

	grid-template-columns:
		80px
		1.5fr
		1fr
		1fr
		1fr;

	align-items: center;

	padding: 1.2rem;

	border-radius: 22px;

	background:
		${({ actual }) =>
			actual
				? "rgba(91,105,226,0.22)"
				: "rgba(255,255,255,0.05)"};

	border:
		1px solid
		${({ actual }) =>
			actual
				? "rgba(91,105,226,0.5)"
				: "rgba(255,255,255,0.08)"};

	@media (max-width: 768px) {

		grid-template-columns: 1fr;

		gap: 0.6rem;
	}
`;

const Rank = styled.div`
	font-size: 1.6rem;
	font-weight: 900;
`;

const Nombre = styled.div`
	font-weight: 700;
`;

const Valor = styled.div`
	color: rgba(255,255,255,0.72);
`;

const Leaderboard = () => {

	const { usuario } = useAuth();

	const [ranking, setRanking] =
		useState([]);

	useEffect(() => {

		const cargar = async () => {

			const snap = await getDocs(
				collection(
					db,
					"progreso_metas"
				)
			);
		
			const raw =
				snap.docs.map((doc) => ({
					id: doc.id,
					...doc.data()
				}));
		
			const agrupado = {};
		
			raw.forEach((item) => {
		
				const uid = item.userId;
		
				if (!agrupado[uid]) {
		
					agrupado[uid] = {
		
						userId: uid,
		
						nombre:
							item.userName ||
							"Jugador",
		
						nivel: 0,
		
						xp: 0,
		
						mejor_streak: 0,
		
						preguntas_correctas: 0,
		
						preguntas_respondidas: 0,

						rankedLp: 0,
						rango: obtenerRango(0)
					};
				}
		
				agrupado[uid].nivel =
					Math.max(
						agrupado[uid].nivel,
						item.nivel || 1
					);
		
				agrupado[uid].xp +=
					item.xp || 0;
		
					agrupado[uid].rankedLp =
					Math.max(
						agrupado[uid].rankedLp,
						item.rankedLp || 0
					);
				
				agrupado[uid].rango =
					obtenerRango(
						agrupado[uid].rankedLp
					);
					
				agrupado[uid].mejor_streak =
					Math.max(
						agrupado[uid]
							.mejor_streak,
						item.mejor_streak || 0
					);
		
				agrupado[uid]
					.preguntas_correctas +=
					item.preguntas_correctas || 0;
		
				agrupado[uid]
					.preguntas_respondidas +=
					item.preguntas_respondidas || 0;
			});
		
			const final =
				Object.values(agrupado);
		
			final.sort((a, b) => {
		
				const xpA =
					a.nivel * 1000 + a.xp;
		
				const xpB =
					b.nivel * 1000 + b.xp;
		
				return xpB - xpA;
			});
		
			setRanking(final);
		};

		cargar();

	}, []);

	return (

		<Contenedor>

			<Titulo>
				🏆 Ranking Global
			</Titulo>

			<Tabla>

				{ranking.map((u, i) => {

					const precision =
						u.preguntas_respondidas > 0
							? Math.round(
								(
									u.preguntas_correctas /
									u.preguntas_respondidas
								) * 100
							)
							: 0;

					return (

						<Fila
							key={u.id}
							actual={
								u.userId ===
								usuario?.uid
							}
						>

							<Rank>
								#{i + 1}
							</Rank>

							<Nombre>

								<div>
									{u.nombre || "Jugador"}
								</div>

								<div
									style={{
										fontSize: ".8rem",
										color: u.rango.color,
										marginTop: "4px"
									}}
								>

									{u.rango.icono}
									{" "}
									{u.rango.nombre}

								</div>

							</Nombre>

							<Valor>
								Nivel {u.nivel}
							</Valor>

							<Valor>
								🔥 x
								{u.mejor_streak || 0}
							</Valor>

							<Valor>
								🏆 {u.rankedLp || 0} LP
							</Valor>

							<Valor>
								🎯 {precision}%
							</Valor>

						</Fila>
					);
				})}

			</Tabla>

		</Contenedor>
	);
};

export default Leaderboard;